module.exports = __webpack_public_path__ + "static/img/partner-dmxm.117d50d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-dmxm.png
// module id = mDEj
// module chunks = 34